module.exports = __webpack_public_path__ + "67c1bb9aeb0559f60583fd790fc57ba4.pdf";